var acc = document.getElementsByClassName("accordion");

for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");

    // Start with the current element
    let current = this;

    // Traverse to next element until we find a .panel or reach the end
    let panel = current.nextElementSibling;
    while (panel && !panel.classList.contains("panel")) {
      panel = panel.nextElementSibling;
    }

    if (!panel) {
      console.warn("No matching panel found for accordion:", this);
      return;
    }

    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}